import { localizations as coreLocalizations } from '@tango/app/localizations';

import common from './common.localizations';
import { ls } from './ls';

export const localizations = Object.assign({}, coreLocalizations, {
  ls: Object.assign({}, coreLocalizations.ls, ls)
});
